import mainRoutes from "./main-routes";
import customerRoutes from "./customer-routes";

const routes = [
    ...mainRoutes,
    ...customerRoutes];

export default routes;